import { PermissionsChangedEnum } from './permissions-changed.enum';

export function isPermissionsSet(
  change: PermissionsChangedEnum | null | undefined
): boolean {
  return change === PermissionsChangedEnum.Set;
}

export function hasPermissionStateInitialized(
  change: PermissionsChangedEnum | null | undefined
): boolean {
  return change !== PermissionsChangedEnum.Uninitialized;
}
